// Chakra imports
import {
	Avatar,
	Button,
	Flex,
	Icon,
	Link,
	SimpleGrid,
	Text,
	useColorModeValue,
} from "@chakra-ui/react";
// Assets
import Card from "components/card/Card";
import { HSeparator } from "components/separator/Separator";
import InnerContent from "layouts/innerContent";
import React from "react";
import { IoIosStar } from "react-icons/io";
import { MdChevronRight } from "react-icons/md";
import avatar1 from "assets/img/testimonials/avatar-1.png";
import avatar2 from "assets/img/testimonials/avatar-2.png";
import avatar3 from "assets/img/testimonials/avatar-3.png";
import avatar4 from "assets/img/testimonials/avatar-4.png";
import avatar5 from "assets/img/testimonials/avatar-5.png";
import avatar6 from "assets/img/testimonials/avatar-6.png";

export default function Testimonials() {
	// Chakra Color Mode

	const textColor = useColorModeValue("#09090B", "white");
	const borderColor = useColorModeValue("gray.300", "white");
	return (
		<Flex
			// bg={bg}
			bgSize='cover'
			w='100%'
			direction={{ base: "column" }}
			pb={{ base: "90px", md: "90px", lg: "100px", xl: "160px" }}
			overflow='hidden'
			position='relative'
			justifyContent='center'
			alignItems='center'>
			<Flex
				pt={{
					base: "40px",
					md: "100px",
					lg: "100px",
					xl: "100px",
					"2xl": "160px",
					"3xl": "160px",
				}}
				mx={{ base: "20px", md: "40px", "2xl": "0px" }}
				w={{ lg: "100%", "2xl": "80vw" }}
				borderRadius={{ base: "20px", md: "50px" }}
				bg='linear-gradient(180deg, #F4F4F5 0%, rgba(255, 255, 255, 0.00) 22.26%)'>
				<InnerContent>
					<Flex
						direction='column'
						mx='auto'
						mb={{ base: "30px", md: "50px" }}
						alignItems='center'
						justify={"center"}
						textAlign='center'>
						<Text
							as='h3'
							textAlign={{ base: "center", lg: "center" }}
							fontWeight='700'
							letterSpacing='2px'
							color={textColor}
							fontSize={{ base: "xs", md: "md" }}
							w={{ base: "60%", md: "100%", lg: "100%", xl: "100%" }}
							mb='10px'>
							OUR CUSTOMERS LOVE US
						</Text>
						<Text
							as='h2'
							textAlign={{ base: "center" }}
							color={textColor}
							fontWeight='800'
							fontSize={{ base: "28px", md: "48px", lg: "48px", xl: "48px" }}
							lineHeight={{ base: "38px", md: "60px", lg: "60px", xl: "60px" }}
							w={{ base: "100%", md: "100%", lg: "100%", xl: "100%" }}
							px={{ xl: "100px" }}
							mb={{ base: "20px", md: "20px" }}
							mx='auto'>
							What our customers say
						</Text>
						<Text
							color='#52525B'
							fontSize={{ base: "md", md: "md", xl: "lg" }}
							fontWeight='500'
							letterSpacing='0px'
							lineHeight={{ base: "24px", md: "30px" }}
							w={{
								base: "92%",
								md: "82%",
								lg: "60%",
								xl: "54%",
								"2xl": "54%",
							}}>
							Startups and many companies from all around the world love our
							services. If you don't believe our words, you may trust their
							testimonials.
						</Text>
					</Flex>
					<SimpleGrid
						columns={{ base: "1", md: "1", lg: "2" }}
						gap='20px'
						mb={{ base: "60px", xl: "90px" }}>
						<Card
							justifyContent={"left"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='left'
							gap='10px'
							py='20px'>
							<Text
								textAlign={"left"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								We are extremely satisfied
							</Text>
							<Text
								textAlign={"left"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								mb='24px'>
								“The rental platform they developed is loaded with all the
								necessary functionalities, making it incredibly easy to use for
								both our team and our customers. From booking to managing
								rentals, everything is streamlined and efficient. The technical
								support has always been prompt, knowledgeable, and efficient.
								The user feedback has been overwhelmingly positive, and we've
								seen a marked increase in our rental bookings.”
							</Text>
							<Flex
								justifyContent='space-between'
								flexDirection={{ base: "column", md: "row" }}>
								<Flex flexDirection={{ base: "column", md: "row" }}>
									<Avatar src={avatar1} />
									<Flex
										ms={{ base: "0px", md: "10px" }}
										mt={{ base: "10px", md: "0px" }}
										flexDirection='column'>
										<Text
											textAlign={"left"}
											fontWeight={"700"}
											fontSize='md'
											color={textColor}
											letterSpacing='0px'>
											Eusebie Cuibari
										</Text>
										<Text
											textAlign={"left"}
											fontWeight={"500"}
											fontSize='sm'
											color='#52525B'
											letterSpacing='0px'>
											Founder of
											<Link
												href='https://elei.ro/?ref=horizon-ui.com'
												isExternal>
												<Text
													as='span'
													fontWeight={"700"}
													fontSize='sm'
													ms='2px'
													color='brand.500'
													letterSpacing='0px'>
													ELEI Rent a Car
												</Text>
											</Link>
										</Text>
									</Flex>
								</Flex>
								<Flex
									justify={{ base: "start", md: "end" }}
									alignItems='center'
									mt={{ base: "10px", md: "0px" }}
									gap='4px'>
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
								</Flex>
							</Flex>
						</Card>
						<Card
							justifyContent={"left"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='left'
							gap='10px'
							py='20px'>
							<Text
								textAlign={"left"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								They were great to work with
							</Text>
							<Text
								textAlign={"left"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								mb='24px'>
								“As a partner managing a UI Kit marketplace, I needed a highly
								professional and visually appealing website for one of our AI
								tools. This agency delivered beyond my expectations! The design
								is sleek, modern, and incredibly functional. They understood our
								vision perfectly and implemented features that enhance user
								experience and streamline our operations. Their team was
								communicative, innovative, and always available to address any
								queries.”
							</Text>
							<Flex
								justifyContent='space-between'
								flexDirection={{ base: "column", md: "row" }}>
								<Flex flexDirection={{ base: "column", md: "row" }}>
									<Avatar src={avatar2} />
									<Flex
										ms={{ base: "0px", md: "10px" }}
										mt={{ base: "10px", md: "0px" }}
										flexDirection='column'>
										<Text
											textAlign={"left"}
											fontWeight={"700"}
											fontSize='md'
											color={textColor}
											letterSpacing='0px'>
											Alexandru Paduraru
										</Text>
										<Text
											textAlign={"left"}
											fontWeight={"500"}
											fontSize='sm'
											color='#52525B'
											letterSpacing='0px'>
											Managing Partner at
											<Link
												href='https://creative-tim.com/?ref=horizon-ui.com'
												isExternal>
												<Text
													as='span'
													fontWeight={"700"}
													fontSize='sm'
													ms='2px'
													color='brand.500'
													letterSpacing='0px'>
													Creative Tim
												</Text>
											</Link>
										</Text>
									</Flex>
								</Flex>
								<Flex
									justify={{ base: "start", md: "end" }}
									alignItems='center'
									mt={{ base: "10px", md: "0px" }}
									gap='4px'>
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
								</Flex>
							</Flex>
						</Card>
						<Card
							justifyContent={"left"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='left'
							gap='10px'
							py='20px'>
							<Text
								textAlign={"left"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								High-quality development process
							</Text>
							<Text
								textAlign={"left"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								mb='24px'>
								“Working with this development agency was an absolute pleasure!
								Their team created a website that perfectly reflects the style
								and elegance of our brand. From the initial consultation to the
								final launch, their attention to detail and dedication to our
								project were evident. Our online sales have significantly
								increased, and our customers are extremely satisfied with the
								seamless shopping experience.”
							</Text>
							<Flex
								justifyContent='space-between'
								flexDirection={{ base: "column", md: "row" }}>
								<Flex flexDirection={{ base: "column", md: "row" }}>
									<Avatar src={avatar3} />
									<Flex
										ms={{ base: "0px", md: "10px" }}
										mt={{ base: "10px", md: "0px" }}
										flexDirection='column'>
										<Text
											textAlign={"left"}
											fontWeight={"700"}
											fontSize='md'
											color={textColor}
											letterSpacing='0px'>
											Adela Parkson
										</Text>
										<Text
											textAlign={"left"}
											fontWeight={"500"}
											fontSize='sm'
											color='#52525B'
											letterSpacing='0px'>
											Co-Founder of
											<Link
												href='https://tts-generator.com/?ref=horizon-ui.com'
												isExternal>
												<Text
													as='span'
													fontWeight={"700"}
													fontSize='sm'
													ms='2px'
													color='brand.500'
													letterSpacing='0px'>
													TTS Generator
												</Text>
											</Link>
										</Text>
									</Flex>
								</Flex>
								<Flex
									justify={{ base: "start", md: "end" }}
									alignItems='center'
									mt={{ base: "10px", md: "0px" }}
									gap='4px'>
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
								</Flex>
							</Flex>
						</Card>
						<Card
							justifyContent={"left"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='left'
							gap='10px'
							py='20px'>
							<Text
								textAlign={"left"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								Great choice for our app development
							</Text>
							<Text
								textAlign={"left"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								mb='24px'>
								“The team did an amazing job developing our docking stations
								app. The app is intuitive, stable, and user-friendly, which has
								been very well received by our users. From the initial design
								phase to the final launch, the communication with the agency was
								excellent. They were always available to answer questions, and
								make necessary adjustments. The app's performance has been
								outstanding, and it has greatly enhanced our operational
								efficiency.”
							</Text>
							<Flex
								justifyContent='space-between'
								flexDirection={{ base: "column", md: "row" }}>
								<Flex flexDirection={{ base: "column", md: "row" }}>
									<Avatar src={avatar4} />
									<Flex
										ms={{ base: "0px", md: "10px" }}
										mt={{ base: "10px", md: "0px" }}
										flexDirection='column'>
										<Text
											textAlign={"left"}
											fontWeight={"700"}
											fontSize='md'
											color={textColor}
											letterSpacing='0px'>
											Marian Musat
										</Text>
										<Text
											textAlign={"left"}
											fontWeight={"500"}
											fontSize='sm'
											color='#52525B'
											letterSpacing='0px'>
											Chief Executive Officer at
											<Link
												href='https://citydock.ro/?ref=horizon-ui.com'
												isExternal>
												<Text
													as='span'
													fontWeight={"700"}
													fontSize='sm'
													ms='2px'
													color='brand.500'
													letterSpacing='0px'>
													City Dock
												</Text>
											</Link>
										</Text>
									</Flex>
								</Flex>
								<Flex
									justify={{ base: "start", md: "end" }}
									alignItems='center'
									mt={{ base: "10px", md: "0px" }}
									gap='4px'>
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
								</Flex>
							</Flex>
						</Card>
						<Card
							justifyContent={"left"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='left'
							gap='10px'
							py='20px'>
							<Text
								textAlign={"left"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								Outstanding collaboration
							</Text>
							<Text
								textAlign={"left"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								mb='24px'>
								“I had an extraordinary experience working with this agency's
								team. Our online course app was developed exactly as we
								envisioned, with all the features needed to provide an
								exceptional learning experience. The process was smooth, from
								planning to execution, and the team was always available to
								address any questions or concerns. Collaboration was very easy
								and pleasant, and the final product exceeded our expectations.”
							</Text>
							<Flex
								justifyContent='space-between'
								flexDirection={{ base: "column", md: "row" }}>
								<Flex flexDirection={{ base: "column", md: "row" }}>
									<Avatar src={avatar5} />
									<Flex
										ms={{ base: "0px", md: "10px" }}
										mt={{ base: "10px", md: "0px" }}
										flexDirection='column'>
										<Text
											textAlign={"left"}
											fontWeight={"700"}
											fontSize='md'
											color={textColor}
											letterSpacing='0px'>
											Rares Toma
										</Text>
										<Text
											textAlign={"left"}
											fontWeight={"500"}
											fontSize='sm'
											color='#52525B'
											letterSpacing='0px'>
											Chief Technical Officer at
											<Link
												href='https://loopple.com/?ref=horizon-ui.com'
												isExternal>
												<Text
													as='span'
													fontWeight={"700"}
													fontSize='sm'
													ms='2px'
													color='brand.500'
													letterSpacing='0px'>
													Loopple
												</Text>
											</Link>
										</Text>
									</Flex>
								</Flex>
								<Flex
									justify={{ base: "start", md: "end" }}
									alignItems='center'
									mt={{ base: "10px", md: "0px" }}
									gap='4px'>
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
								</Flex>
							</Flex>
						</Card>
						<Card
							justifyContent={"left"}
							borderRadius={{ base: "10px", md: "16px" }}
							alignItems='left'
							gap='10px'
							py='20px'>
							<Text
								textAlign={"left"}
								fontWeight={"bold"}
								fontSize={{ base: "lg", lg: "lg", xl: "xl" }}
								mb='8px'
								color={textColor}>
								Impressive development expertise
							</Text>
							<Text
								textAlign={"left"}
								fontWeight={"500"}
								fontSize='sm'
								lineHeight='24px'
								color='#52525B'
								letterSpacing='0px'
								mb='24px'>
								“Our experience has been nothing short of exceptional. They
								created an advanced AI-powered SaaS website for our educational
								services, and the results have been phenomenal. The website is
								highly responsive, easy to navigate, and integrates seamlessly
								with our AI tools. Their expertise and dedication were evident
								throughout the project, and they were always ready to go the
								extra mile to ensure everything met our requirements.”
							</Text>
							<Flex
								justifyContent='space-between'
								flexDirection={{ base: "column", md: "row" }}>
								<Flex flexDirection={{ base: "column", md: "row" }}>
									<Avatar src={avatar6} />
									<Flex
										ms={{ base: "0px", md: "10px" }}
										mt={{ base: "10px", md: "0px" }}
										flexDirection='column'>
										<Text
											textAlign={"left"}
											fontWeight={"700"}
											fontSize='md'
											color={textColor}
											letterSpacing='0px'>
											Bogdan G. Mihalache
										</Text>
										<Text
											textAlign={"left"}
											fontWeight={"500"}
											fontSize='sm'
											color='#52525B'
											letterSpacing='0px'>
											Co-Founder of
											<Link
												href='https://eduwiz.ai/?ref=horizon-ui.com'
												isExternal>
												<Text
													as='span'
													fontWeight={"700"}
													fontSize='sm'
													ms='2px'
													color='brand.500'
													letterSpacing='0px'>
													EduWiz.ai
												</Text>
											</Link>
										</Text>
									</Flex>
								</Flex>
								<Flex
									justify={{ base: "start", md: "end" }}
									alignItems='center'
									mt={{ base: "10px", md: "0px" }}
									gap='4px'>
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
									<Icon as={IoIosStar} w='20px' h='20px' color='orange.300' />
								</Flex>
							</Flex>
						</Card>
					</SimpleGrid>
					<Flex
						direction={"column"}
						h='100%'
						w='100%'
						mx='auto'
						zIndex='3'
						justifyContent='center'
						align='center'>
						<Flex mx='auto' direction={{ base: "column", md: "row" }}>
							<Flex
								align='center'
								direction={{ base: "column", md: "row" }}
								justifyContent={{ base: "center", lg: "center" }}>
								<Link href='#form'>
									<Button
										variant='primaryGradient'
										py='20px'
										px='16px'
										fontSize='md'
										borderRadius='45px'
										me={{ base: "0px", md: "14px" }}
										mb={{ base: "20px", md: "0px" }}
										w={{ base: "300px", lg: "320px" }}
										h='70px'>
										Let’s discuss your Project
										<Icon
											as={MdChevronRight}
											w='16px'
											h='16px'
											mt='3px'
											ms='2px'
											color='white'
										/>
									</Button>
								</Link>
								<Link href='#projects'>
									<Button
										bg='transparent'
										variant='transparent'
										border='1px solid'
										borderColor={borderColor}
										color={textColor}
										my='auto'
										w={{ base: "300px", md: "200px" }}
										h='70px'
										fontSize='md'
										borderRadius='45px'>
										Explore Projects
									</Button>
								</Link>
							</Flex>
						</Flex>
					</Flex>
				</InnerContent>
			</Flex>
			<HSeparator
				mx='auto'
				maxW='1170px'
				mt={{ base: "90px", md: "90px", lg: "100px", xl: "160px" }}
				bg='linear-gradient(270deg, rgba(226, 232, 240, 0.00) 0%, rgba(226, 232, 240, 0.65) 25.52%, #E2E8F0 52.6%, rgba(226, 232, 240, 0.65) 80.21%, rgba(226, 232, 240, 0.00) 100%)'
			/>
		</Flex>
	);
}
